import React, { useState, useEffect } from "react";
import api, { API_ENDPOINTS } from "../config"; // Import API endpoints
import "./Admin.css"; // Import styles
import Sidebar from "./Sidebar";

const AddAdmin = () => {
  const [form, setForm] = useState({ email: "", password: "" });
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [admins, setAdmins] = useState([]); // State to store the list of admins
  const [loading, setLoading] = useState(false); // State for loading
  const [showForm, setShowForm] = useState(false); // State to toggle between table and form
  const [showDeletePopup, setShowDeletePopup] = useState(false); // State to show delete confirmation popup
  const [adminToDelete, setAdminToDelete] = useState(null); // State to store the admin to delete

  // Fetch all admins

   const fetchAdmins = async () => {
      setLoading(true);
      try {
        const response = await api.get(API_ENDPOINTS.GET_ADMINS);
        setAdmins(response.data.admins); // Assuming the API returns an array of admins
      } catch (error) {
        console.error("Error fetching admins:", error);
        setError("Failed to fetch admins. Please try again.");
      } finally {
        setLoading(false);
      }
    };
  useEffect(() => {
   

    fetchAdmins();
  }, []);

  // Handle form input changes
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Handle form submission to add an admin
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess("");
    setError("");

    try {
      const response = await api.post(API_ENDPOINTS.ADD_ADMIN, form, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.status === 201) {
        setSuccess("Admin added successfully!");
        setForm({ email: "", password: "" }); // Clear the form
        setAdmins((prev) => [...prev, response.data]); // Add the new admin to the list
        setShowForm(false); // Hide the form after adding the admin
        await fetchAdmins(); // Refresh the admin list
      } else {
        setError("Failed to add admin. Please try again.");
      }
    } catch (error) {
      console.error("Error adding admin:", error);
      setError(error.response?.data?.message || "An error occurred. Please try again.");
    }
  };

  // Handle delete admin
  const handleDeleteAdmin = async () => {
    if (!adminToDelete) return;

    try {
      const response = await api.delete(`${API_ENDPOINTS.DELETE_ADMIN}${adminToDelete}`);
      if (response.status === 200) {
        setAdmins((prev) => prev.filter((admin) => admin.id !== adminToDelete)); // Remove the deleted admin from the list
        setSuccess("Admin deleted successfully!");
        await fetchAdmins();
      } else {
        setError("Failed to delete admin. Please try again.");
      }
    } catch (error) {
      console.error("Error deleting admin:", error);
      setError("An error occurred while deleting the admin.");
    } finally {
      setShowDeletePopup(false); // Close the delete confirmation popup
      setAdminToDelete(null); // Reset the admin to delete
    }
  };

  return (
    <div className="add-admin-container">
      <Sidebar />
      <div className="header">
        <h2>Admin Management</h2>
        {!showForm && (
          <button className="add-admin-button" onClick={() => setShowForm(true)}>
            Add Admin
          </button>
        )}
      </div>

      {success && <p className="success-message">{success}</p>}
      {error && <p className="error-message">{error}</p>}

      {showForm ? (
        <form onSubmit={handleSubmit} className="add-admin-form">
          <h3>Add Admin</h3>
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={form.email}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={form.password}
            onChange={handleChange}
            required
          />
          <div className="form-actions">
            <button type="submit">Submit</button>
            <button type="button" onClick={() => setShowForm(false)}>
              Cancel
            </button>
          </div>
        </form>
      ) : (
        <div>
          <h3>All Admins</h3>
          {loading ? (
            <p>Loading admins...</p>
          ) : (
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Email</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {admins.map((admin) => (
                  <tr key={admin.id}>
                    <td>{admin.email}</td>
                    <td>
                      <button
                        onClick={() => {
                          setAdminToDelete(admin._id); // Set the admin to delete
                          setShowDeletePopup(true); // Show the delete confirmation popup
                        }}
                        className="delete-btn"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* Delete Confirmation Popup */}
      {showDeletePopup && (
        <div className="delete-popup">
          <div className="delete-popup-content">
            <p>Are you sure you want to delete this admin?</p>
            <div className="popup-actions">
              <button onClick={handleDeleteAdmin} className="confirm-btn">
                Yes, Delete
              </button>
              <button
                onClick={() => {
                  setShowDeletePopup(false);
                  setAdminToDelete(null);
                }}
                className="cancel-btn"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddAdmin;